import React from "react";
import CustomChip from "../../../../components/CustomChip";
import CustomTooltip from "../../../../components/CustomTooltip";
import EventFeedRowApp from "../Functionality/EventFeedRowApp";
import EventMetaItem from "./EventMetaItem";

/**
 * @Author      Karen Yunuen Pozos Arias
 * @JobTitle    Full Stack
 * @Email       kpozos@ibl.mx
 *
 * Row of the event feed: severity bar, severity pictogram, event chip, description, meta items and elapsed time.
 *
 * @param {Object} event - Event received by the socket.
 * @param {number} now - Current timestamp, refreshes the elapsed time.
 */
const EventFeedRow = ({ event, now }) => {
    const { severity, elapsed, metaRows, label, Icon } = EventFeedRowApp({ event, now });

    return (
        <div className='event-monitoring-feed-row event-monitoring-lazy-render background-general-00'>
            <div className={`flex-shrink-0 w-4px ${severity.BORDER_CLASS} ${severity.BACKGROUND_CLASS}`} />
            <div className='event-monitoring-feed-row-content'>
                <div className={`event-monitoring-severity-pictogram w-44px h-44px border-radius-4px ${severity.BACKGROUND_CLASS}`}>
                    <Icon className={`btn-icon-svg-24px ${severity.ICON_CLASS}`} />
                </div>
                <div className='d-flex flex-column flex-grow-1 gap-3 minw-0'>
                    <div className='d-flex align-items-center justify-content-between gap-2'>
                        <div className='d-flex align-items-center gap-2 minw-0'>
                            <CustomChip
                                legend={label}
                                background={severity.BACKGROUND}
                                fontColor={severity.FONT}
                                borderColor={severity.BORDER}
                                variant={event.chipVariant}
                            />
                            {/* The description shrinks and is cut with an ellipsis, so it never covers the elapsed time */}
                            <div className='minw-0'>
                                <CustomTooltip
                                    text={event.description}
                                    classes='d-block fs-14px ibl-font-w-400 font-color-shades-950 text-truncate'
                                    showIfTruncated
                                    placement='top'
                                />
                            </div>
                        </div>
                        <p className='flex-shrink-0 fs-14px font-color-shades-500 text-nowrap'>{elapsed}</p>
                    </div>
                    <div className='d-flex flex-column gap-2'>
                        {metaRows.map((row, rowIndex) => (
                            <div key={rowIndex} className='d-flex flex-wrap align-items-center gap-2'>
                                {row.map((item, index) => (
                                    <EventMetaItem key={index} Icon={item.Icon} label={item.label} value={item.value} showLabel={item.showLabel} />
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

// Memo so a new event at the top of the feed does not render every row again //
export default React.memo(EventFeedRow);
